import * as React from "react";
import { usePageFocused } from "./usePageFocused";
import { getLocalDate } from "src/database/utils/localDate";

function useInterval(callback: Function, time: number) {
  React.useEffect(() => {
    const interval = setInterval(callback, time);
    return () => clearInterval(interval);
  }, [callback, time]);
}

export function useToday() {
  const [today, setToday] = React.useState(new Date());
  const focused = usePageFocused();

  const updateDate = () => {
    const newToday = new Date();
    if (focused && getLocalDate(today) !== getLocalDate(newToday)) {
      setToday(newToday);
    }
  };

  useInterval(() => {
    updateDate();
  }, 1000);

  React.useEffect(() => {
    updateDate();
  }, [focused]);

  return today;
}
